import { useCallback, useMemo } from 'react';
import { useCompoundComponentProviderContext, CompoundComponentValue, Action } from '../CompoundComponentProvider.mjs';
import { useUniqueId } from '../../../../../../../utilities/unique-id/hooks.mjs';

function useCompoundComponent() {
  const context = useCompoundComponentProviderContext();
  const id = useUniqueId('BottomSheet');
  const registerComponent = useCallback((type, props) => {
    let actionType;
    if (!context || !type || !props) {
      return null;
    }
    switch (type) {
      case CompoundComponentValue.Button:
        actionType = Action.RegisterButton;
        break;
      case CompoundComponentValue.Title:
        actionType = Action.RegisterTitle;
        break;
      case CompoundComponentValue.VisuallyHiddenTitle:
        actionType = Action.RegisterVisuallyHiddenTitle;
        break;
    }
    const {
      dispatch
    } = context;
    dispatch({
      type: actionType,
      payload: {
        id,
        ...props
      }
    });
    return id;
  }, [context, id]);
  const updateComponent = useCallback((type, id, props) => {
    let actionType;
    if (!context || !type || !id || !props) {
      return;
    }
    switch (type) {
      case CompoundComponentValue.Button:
        actionType = Action.UpdateButton;
        break;
      case CompoundComponentValue.Title:
        actionType = Action.UpdateTitle;
        break;
      case CompoundComponentValue.VisuallyHiddenTitle:
        actionType = Action.UpdateVisuallyHiddenTitle;
        break;
    }
    const {
      dispatch
    } = context;
    dispatch({
      type: actionType,
      payload: {
        id,
        ...props
      }
    });
  }, [context]);
  const unregisterComponent = useCallback((type, id) => {
    let actionType;
    if (!context || !type || !id) {
      return;
    }
    switch (type) {
      case CompoundComponentValue.Button:
        actionType = Action.UnregisterButton;
        break;
      case CompoundComponentValue.Title:
        actionType = Action.UnregisterTitle;
        break;
      case CompoundComponentValue.VisuallyHiddenTitle:
        actionType = Action.UnregisterVisuallyHiddenTitle;
        break;
    }
    const {
      dispatch
    } = context;
    dispatch({
      type: actionType,
      payload: {
        id
      }
    });
  }, [context]);
  const compoundComponentContext = useMemo(() => ({
    registerComponent,
    updateComponent,
    unregisterComponent
  }), [registerComponent, updateComponent, unregisterComponent]);
  return compoundComponentContext;
}

export { useCompoundComponent };
